import { AuthIndexRouteView } from './view';

export const indexRoute = {
  index: true,
  element: <AuthIndexRouteView/>,
};